module.exports = __webpack_public_path__ + "img/clock.2a63fc04.svg";